import * as React from 'react';
export const customizeBrandSvg = React.forwardRef(
  function customizeBrandSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M5.42.951A1.52 1.52 0 0 1 6.5.498c.398 0 .808.15 1.11.453l.988.991a.03.03 0 0 0 .01.007.047.047 0 0 0 .018.003h1.398c.855 0 1.548.698 1.548 1.551v1.402a.75.75 0 1 1-1.5 0V3.503c0-.025-.028-.05-.048-.05H8.626c-.403 0-.796-.156-1.09-.452l-.988-.99c-.014-.014-.053-.014-.066 0L5.494 3a1.532 1.532 0 0 1-1.09.451H3.006c-.02 0-.048.026-.048.051v1.402c0 .402-.155.795-.449 1.09l-.988.991c-.014.014-.014.058 0 .072l.988.991c.294.295.449.688.449 1.09v1.402c0 .025.027.05.048.05h1.398a.75.75 0 0 1 0 1.5H3.006a1.552 1.552 0 0 1-1.548-1.55V9.139a.054.054 0 0 0-.004-.02.031.031 0 0 0-.007-.01l-.988-.992A1.554 1.554 0 0 1 0 7.012c.003-.394.16-.786.459-1.085l.988-.991a.031.031 0 0 0 .007-.011.053.053 0 0 0 .004-.02V3.503c0-.853.693-1.55 1.548-1.55h1.398a.047.047 0 0 0 .018-.004.03.03 0 0 0 .01-.007l.988-.99ZM.75 14a.75.75 0 0 0 0 1.5h3.753a.75.75 0 0 0 0-1.5H.75Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'm12.863 12.073 2.829-4.394c.204-.308.305-.657.308-1.003a1.798 1.798 0 0 0-.795-1.512 1.808 1.808 0 0 0-2.512.472l-3.049 4.22a2.408 2.408 0 0 0-.037.009c-.722.185-1.446.689-1.765 1.697a13.977 13.977 0 0 1-1.082 2.49.826.826 0 0 0-.057.78c.116.26.349.427.603.478 2.682.615 4.377-.39 5.098-1.424a2.581 2.581 0 0 0 .459-1.813Zm-1.935-.599a1.269 1.269 0 0 0-.945-.157H9.98c-.295.076-.567.252-.708.7l-.003.01a16.23 16.23 0 0 1-.784 1.955c1.585.13 2.4-.54 2.69-.956l.005-.007c.35-.49.23-1.185-.252-1.545Zm.45-1.456c.145.064.282.14.407.225l.01.006.009.007a2.6 2.6 0 0 1 .288.244l2.342-3.639.008-.012a.315.315 0 0 0-.076-.442.308.308 0 0 0-.45.098l-2.539 3.513ZM6.5 8.5a1.5 1.5 0 1 0 .001-3 1.5 1.5 0 0 0-.002 3Zm3-1.498a3 3 0 1 1-6-.004 3 3 0 0 1 6 .004Z',
      }),
    );
  },
);
customizeBrandSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var customizeBrand = {
  category: 'icon',
  colorable: true,
  name: 'customizeBrand',
  svg: customizeBrandSvg,
};
